"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTuberculosisScreeningWorkHistoryQuestionDto = instanceOfTuberculosisScreeningWorkHistoryQuestionDto;
exports.TuberculosisScreeningWorkHistoryQuestionDtoFromJSON = TuberculosisScreeningWorkHistoryQuestionDtoFromJSON;
exports.TuberculosisScreeningWorkHistoryQuestionDtoFromJSONTyped = TuberculosisScreeningWorkHistoryQuestionDtoFromJSONTyped;
exports.TuberculosisScreeningWorkHistoryQuestionDtoToJSON = TuberculosisScreeningWorkHistoryQuestionDtoToJSON;
exports.TuberculosisScreeningWorkHistoryQuestionDtoToJSONTyped = TuberculosisScreeningWorkHistoryQuestionDtoToJSONTyped;
/**
 * Check if a given object implements the TuberculosisScreeningWorkHistoryQuestionDto interface.
 */
function instanceOfTuberculosisScreeningWorkHistoryQuestionDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('question' in value) || value['question'] === undefined)
        return false;
    return true;
}
function TuberculosisScreeningWorkHistoryQuestionDtoFromJSON(json) {
    return TuberculosisScreeningWorkHistoryQuestionDtoFromJSONTyped(json, false);
}
function TuberculosisScreeningWorkHistoryQuestionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'question': json['question'],
        'subtext': json['subtext'] == null ? undefined : json['subtext'],
        'answer': json['answer'] == null ? undefined : json['answer'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
    };
}
function TuberculosisScreeningWorkHistoryQuestionDtoToJSON(json) {
    return TuberculosisScreeningWorkHistoryQuestionDtoToJSONTyped(json, false);
}
function TuberculosisScreeningWorkHistoryQuestionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'question': value['question'],
        'subtext': value['subtext'],
        'answer': value['answer'],
        'date': value['date'] == null ? undefined : ((value['date']).toISOString().substring(0, 10)),
    };
}
//# sourceMappingURL=TuberculosisScreeningWorkHistoryQuestionDto.js.map